<template>
  <v-dialog v-model="dialog" width="500" 
    :persistent="changed"
    @keydown.esc="closeCommentDialog()"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <span >{{commentContext}}</span>
      </v-card-title>
      <v-card-text pa-1>
          <v-textarea
            ref="textArea"
            name="input-7-1"
            v-model="commentTextInput"
            auto-grow
            @keyup.13.prevent="onEnter"
            @input="changed = true"
          ></v-textarea>
          <div v-if="mutatingComment && mutatingComment.timestamp" class="caption text-xs-right grey--text">
              {{mutatingComment.userByUserId.fullName}}
              {{$d(new Date(mutatingComment.timestamp), 'long')}}
          </div>
        </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-layout row justify-space-between pb-3 v-if="mutatingComment">
          <v-btn color="grey-lighten-3" flat @click="closeCommentDialog()">Avbryt</v-btn>
          <!--
          <v-btn 
            color="error" 
            dark
            @click="deleteComment(mutatingComment)">Radera</v-btn>
          -->
          <v-btn 
            color="success" 
            :dark="!checkForCommentUpdate(mutatingComment, commentTextInput)"
            :disabled="checkForCommentUpdate(mutatingComment, commentTextInput)"
            @click="onSubmit">Spara</v-btn>
        </v-layout>
        <v-layout v-else row justify-space-between pb-3>
          <v-btn color="grey-lighten-3" flat @click="closeCommentDialog()">Avbryt</v-btn>
          <v-btn 
            color="success"
            :dark="commentTextInput !== null"
            :disabled="commentTextInput === null"
            @click="onSubmit">Spara</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  addCommentMutation,
  updateCommentByIdMutation,
  deleteCommentByIdMutation
} from "@/graphql/commentQueries.gql";
export default {
  apollo: {

  },
  data() {
    return {
      dialog: false,
      commentingOnParticipant: null,
      commentingOnIndicator: null,
      commentingOnCategory: null,
      commentTextInput: null,
      mutatingComment: null,
      changed: false
    }
  },
  computed: {
    commentsFromIds(){
      var comments = []
      for(var comment of this.allComments.nodes){
        if(this.commentingOnIndicator && comment.indicatorId === this.commentingOnIndicator.id){
          comments.push(comment)
        }
        else if(this.commentingOnCategory && comment.categoryId === this.commentingOnCategory.id){
          comments.push(comment)
        }
        else if(this.commentingOnParticipant && comment.participantId === this.commentingOnParticipant.id){
          comments.push(comment)
        }
        else if(!this.commentingOnCategory && !this.commentingOnIndicator && !this.commentingOnParticipant &&
        !comment.categoryId && !comment.participantId && !comment.indicatorId){
          console.log(comment)
          comments.push(comment)
        }
      }
      return comments
    },
    commentContext(){
      var context = ""
        if(this.commentingOnIndicator){
          context = this.commentingOnIndicator.title
        }
        else if(this.commentingOnCategory){
          context = this.commentingOnCategory.title
        }else {
          context = "Kommentar på hela utvärderingen"
        }
      return context
    }
  },
  methods: {
    checkForCommentUpdate(originalComment, currentContent = null){
      if(originalComment){
        if(originalComment.content === currentContent){
          return true
        }
      }
      return false
    },
    addComment(textInput, participant = null, indicator = null, category = null) {
      //Add comment by mutation
      if (
        textInput
      ) {
        var participantId
        if(participant) participantId = participant.id
        var indicatorId
        if(indicator) indicatorId = indicator.id
        var categoryId
        if(category) categoryId = category.id
        console.log("adding comment")
        this.$apollo
          .mutate({
            mutation: addCommentMutation,
            variables: {
              CommentData: {
                comment: {
                  id: this.guid(),
                  evaluationId: this.evaluationId,
                  participantId: participantId,
                  userId: this.currentUser.id,
                  indicatorId: indicatorId,
                  categoryId: categoryId,
                  content: textInput
                }
              }
            }
          })
          .then(data => {
            console.log(data);
            //this.$apollo.queries.allComments.refetch();
            this.$emit('commentEvent')
          });
      }
      this.commentTextInput = null;
      //console.log(textInput)
      this.closeCommentDialog()
    },
    mutateComment(textInput, comment) {
      //Add comment by mutation
      if (
        textInput && comment
      ) {
        var commentId = comment.id
        console.log("mutating comment")
        this.$apollo
          .mutate({
            mutation: updateCommentByIdMutation,
            variables: {
              CommentData: {
                id: commentId,
                commentPatch: {
                  content: textInput
                }
              }
            }
          })
          .then(data => {
            console.log(data);
            //this.$apollo.queries.allComments.refetch();
            this.$emit('commentEvent')
          });
      }
      //this.commentTextInput = null;
      //console.log(textInput)
      this.closeCommentDialog()
    },
    deleteComment(comment){
      if (comment) {
        var commentId = comment.id
        console.log("deleting comment")
        this.$apollo
          .mutate({
            mutation: deleteCommentByIdMutation,
            variables: {
              CommentId:{
                id: commentId
              }
            }
          })
          .then(data => {
            console.log(data);
            //this.$apollo.queries.allComments.refetch();
            this.$emit('commentEvent')
            this.closeCommentDialog()
          });
        }
    },
    closeCommentDialog(){
      this.dialog = false
      this.commentingOnCategory = null
      this.commentingOnParticipant = null
      this.commentingOnIndicator = null
      this.mutatingComment = null
      this.$emit('closeDialog')
    },
    openDialog(indicator = null, category = null, participant = null) {
      this.commentTextInput = null
      this.mutatingComment = null
      this.commentingOnParticipant = participant
      this.commentingOnIndicator = indicator
      this.commentingOnCategory = category

      if(this.commentsFromIds.length > 0){
        this.mutatingComment = this.commentsFromIds[0]
        this.commentTextInput = this.commentsFromIds[0].content
      }

      this.dialog = true
      this.changed = false
      this.$nextTick(() => {
        this.$refs.textArea.focus()
      })
    },
    onEnter(event) {
      if (event.ctrlKey) {
        event.preventDefault()
        this.onSubmit()
      }
    },
    onSubmit() {
      if(this.mutatingComment){
        if (this.commentTextInput && this.commentTextInput.trim().length > 0) {
          this.mutateComment(this.commentTextInput, this.mutatingComment)
        } else {
          this.deleteComment(this.mutatingComment)
        }
      } else if (this.commentTextInput && this.commentTextInput.trim().length > 0) {
        this.addComment(this.commentTextInput, this.commentingOnParticipant, this.commentingOnIndicator, this.commentingOnCategory)
      }
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      }
  },

  // props: ['open','commentingOnParticipant', 'commentingOnIndicator','commentingOnCategory', 'allComments', 'evaluationId'],
  props: ['allComments', 'evaluationId', 'currentUser'],
}
</script>